import { default as ControlsThemeRaw } from "./10-controls.json";
import { default as ControlsTheme6Raw } from "./11-controls-6.json";

import type { IThemePackage } from "@bissantz/theme/lib/theme";

export const ControlsThemePackage: IThemePackage = ControlsThemeRaw;
export const ControlsTheme6Package: IThemePackage = ControlsTheme6Raw;
